/**
 * useCategorySelection — Manages goal category filter selection state.
 */
import { useState } from "react";

export const useCategorySelection = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | undefined>();
  
  return {
    selectedCategory,
    setSelectedCategory,
  };
};
